import React, {useEffect, useState} from 'react'
import Layout from '../../../components/layout/Layout'
import {sendData} from '../../../store/actions'
import {useDispatch, useSelector} from 'react-redux'
import {isElectron} from '../../../common/functions'
import {checkCookie, eraseCookie, getCookie} from 'ubs-framework/v2/common/cookie';
import useSocket from '../../common/useSocket'
import AppHeader from '../../common/components/app-header'
import Commonrightcircle from '../../../common/component/RightCircle/commonrightcircle'
import * as Icon from 'ubs-icons'
import {useHistory} from 'react-router-dom'
import CommonInvite from '../../../common/component/CommonInvite/CommonInvite'
import {UAvatar} from "ubs-framework";
import {planMerger} from 'ubs-framework/v2/common/convert';
import SetUpMultiFactor from '../setup-multi-factor';
import {withRouter} from "../../../common/hocs/routing-hoc";

function Workspace(props) {
    const dispatch = useDispatch()
    const history = useHistory()

    const _COMMON = useSelector(e => e.common)
    const _ADMIN = useSelector(e => e.common?.isAdmin)
    const _AP = useSelector(e => e?.common?.planAccess)
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);
    const _LID = useSelector(e => e.common.logInDetails)
    const _IA = useSelector(e => e.common.authData)

    const [disabledBtn, setDisabledBtn] = useState(true)
    const [hasData, setHasData] = useState(false)
    const [selectedOrg, setSelectedOrg] = useState({})
    const [selectModule, setSelectModule] = useState('')
    const [list, setList] = useState([])
    const [isProductAccess, setIsProductAccess] = useState(false)

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'getWorkspaceList': {
                    const list = res.data.list?.map(e => {
                        e.planAccess = planMerger(e?.planAccess, e?.productAccess, e?.isAdmin)
                        return e
                    })
                    setDisabledBtn(false)
                    let accessFlag = 0
                    for (let i in _AP) {
                        if (_AP[i]?.default?.access) accessFlag++
                    }
                    if (checkCookie('previousURL') && _COMMON?.role !== 'client') window.location.href = getCookie('previousURL')
                    else if (accessFlag === 1) {
                        if (_AP?.hrms?.default?.access) window.location.href = `${process.env.REACT_APP_HRMS_MODULE_URL}/${res.data?.list?.[0]?.orgId}/dashboard`
                        else if (_AP?.chat?.default?.access) window.location.href = `${process.env.REACT_APP_CHAT_MODULE_URL}/${res.data?.list?.[0]?.orgId}/`
                        else if (_AP?.pms?.default?.access) {
                            if (res?.data?.list?.length === 1) {
                                if (window?.electron?.remote?.app?.getName()?.includes('Track')) window.location.href = `${process.env.REACT_APP_TRACK_MODULE_URL}/${res.data?.list?.[0]?.orgId}/`
                                else window.location.href = `${process.env.REACT_APP_PMS_MODULE_URL}/${res.data?.list?.[0]?.orgId}/`
                            } else {
                                setHasData(true)
                                setList(list)
                                setSelectedOrg(res.data.activeOrgId ? list.find(e => e.orgId === res.data.activeOrgId) : list[0])
                            }
                        } else if (_AP?.payroll?.default?.access) window.location.href = `${process.env.REACT_APP_PAYROLL_MODULE_URL}/${res.data?.list?.[0]?.orgId}/`
                        else if (_ADMIN && _AP?.survey?.default?.access) window.location.href = `${process.env.REACT_APP_SURVEY_MODULE_URL}/${res.data?.list?.[0]?.orgId}/`
                        else if (_AP?.recruit?.default?.access) window.location.href = `${process.env.REACT_APP_RECRUIT_MODULE_URL}/${res.data?.list?.[0]?.orgId}/`
                        else if (_AP?.assets?.default?.access) window.location.href = `${process.env.REACT_APP_ASSETS_MODULE_URL}/${res.data?.list?.[0]?.orgId}/`
                    } else {
                        setHasData(true)
                        setList(list)
                        /**
                         * If we get activeOrgId from event response it means you have previous worked org in your history
                         * so you have to by default select that org
                         * otherwise select first org
                         * */
                        setSelectedOrg(res.data.activeOrgId ? list.find(e => e.orgId === res.data.activeOrgId) : list[0])
                    }
                    off()
                    break
                }
                case 'loginEmail' :
                    if (selectModule === 'hrms' && selectedOrg?.planAccess?.hrms?.default?.access) window.location.href = `${process.env.REACT_APP_HRMS_MODULE_URL}/${selectedOrg?.orgId}/dashboard`
                    else if (selectModule === 'chat' && selectedOrg?.planAccess?.chat?.default?.access) window.location.href = `${process.env.REACT_APP_CHAT_MODULE_URL}/${selectedOrg?.orgId}/`
                    else if (selectModule === 'pms' && selectedOrg?.planAccess?.pms?.default?.access) {
                        if (window?.electron?.remote?.app?.getName()?.includes('Track')) window.location.href = `${process.env.REACT_APP_TRACK_MODULE_URL}/${selectedOrg?.orgId}/`
                        else window.location.href = `${process.env.REACT_APP_PMS_MODULE_URL}/${selectedOrg?.orgId}/`
                    } else if (selectModule === 'payroll' && selectedOrg?.planAccess?.payroll?.default?.access) window.location.href = `${process.env.REACT_APP_PAYROLL_MODULE_URL}/${selectedOrg?.orgId}/`
                    else if (selectModule === 'survey' && _ADMIN && selectedOrg?.planAccess?.survey?.default?.access) window.location.href = `${process.env.REACT_APP_SURVEY_MODULE_URL}/${selectedOrg?.orgId}/`
                    else if (selectModule === 'recruit' && selectedOrg?.planAccess?.recruit?.default?.access) window.location.href = `${process.env.REACT_APP_RECRUIT_MODULE_URL}/${selectedOrg?.orgId}/`
                    else if (selectModule === 'assets' && selectedOrg?.planAccess?.assets?.default?.access) window.location.href = `${process.env.REACT_APP_ASSETS_MODULE_URL}/${selectedOrg?.orgId}/`
                    else {

                    }
                    break
                default:
                    return true
            }
        }
    })

    const handle = {
        editSetupMFA: () => {
            history.push(props?.projectRoutes?.setupMultiFactor || '/setup-multi-factor')
        }
    }

    useEffect(() => {
        setSelectModule(isElectron() ? (window?.electron?.remote?.app?.getName()?.includes('Track') ? 'pms' : 'chat') : _COMMON?.role === 'client' ? 'pms' : 'hrms')
        if (_AP) {
            Object.keys(_AP)?.forEach(key => {
                if (_AP[key]?.default?.access) setIsProductAccess(_AP[key]?.default?.access)
            })
        }
    }, [])

    useEffect(() => {
        if (_COMMON?.isAuthenticated) sendData(dispatch, 'getWorkspaceList', {requirePlanDetails: true})
        refresh()
        return () => off()
    }, [])

    const selectOrg = data => {
        setDisabledBtn(false)
        setSelectedOrg(data)
        localStorage.setItem('selectedLogo', data.logoURL ? `${_S3_BASE_URL}${data.logoURL}` : '');
        if (data?.role === 'client') setSelectModule('pms');
    }

    const submit = () => {
        if (selectModule?.length) {
            if (_COMMON?.email?.length > 0) {
                let data = {
                    email: _COMMON?.email,
                    orgId: selectedOrg.orgId,
            }
            if (isElectron()) data.appType = window?.electron?.remote?.app?.getName()?.includes('Track') ? 'superTrack' : 'superChat';
                setDisabledBtn(true)
                refresh()
                sendData(dispatch, 'loginEmail', data)
            } else {
                if (selectModule === 'hrms' && _AP?.hrms?.default?.access) window.location.href = `${process.env.REACT_APP_HRMS_MODULE_URL}/${selectedOrg?.orgId}/dashboard`
                else if (selectModule === 'chat' && _AP?.chat?.default?.access) window.location.href = `${process.env.REACT_APP_CHAT_MODULE_URL}/${selectedOrg?.orgId}/`
                else if (selectModule === 'pms' && _AP?.pms?.default?.access) {
                    if (window?.electron?.remote?.app?.getName()?.includes('Track')) window.location.href = `${process.env.REACT_APP_TRACK_MODULE_URL}/${selectedOrg?.orgId}/`
                    else window.location.href = `${process.env.REACT_APP_PMS_MODULE_URL}/${selectedOrg?.orgId}/`
                } else if (selectModule === 'payroll' && _AP?.payroll?.default?.access) window.location.href = `${process.env.REACT_APP_PAYROLL_MODULE_URL}/${selectedOrg?.orgId}/`
                else if (selectModule === 'survey' && _ADMIN && _AP?.survey?.default?.access) window.location.href = `${process.env.REACT_APP_SURVEY_MODULE_URL}/${selectedOrg?.orgId}/`
                else if (selectModule === 'recruit' && _AP?.recruit?.default?.access) window.location.href = `${process.env.REACT_APP_RECRUIT_MODULE_URL}/${selectedOrg?.orgId}/`
                else if (selectModule === 'assets' && _AP?.assets?.default?.access) window.location.href = `${process.env.REACT_APP_ASSETS_MODULE_URL}/${selectedOrg?.orgId}/`
            }
        }
    }
    const logout = () => {
        if (localStorage.getItem('notification_token')) sendData('logout', {device_token: localStorage.getItem('notification_token')})
        dispatch({type: 'LOGOUT'})
        localStorage.clear()
        eraseCookie('ubs_token')
        eraseCookie('ubsTabId')
        history.push('/login')
        window.location.reload(true)
    }
    return (
        <React.Fragment>
            {hasData && <Layout>
                <Commonrightcircle/>
                {selectedOrg?.logoURL && (<div className="top-right-logo">
                    <img className="u_logo-top" height={70} width={70} src={`${_S3_BASE_URL}${selectedOrg?.logoURL}`} alt="Logo" />
                </div>)}
                <div className="u_account-form u_relative">
                    {!isProductAccess ? (
                        <React.Fragment>
                            <img src="../images/images/oops.png" className="u_m-auto"/>
                            <CommonInvite heading="Oops!" title="Please contact the system administrator to get product access."/>
                            <div className="u_block u_relative">
                                <button type="button" onClick={() => window.location.reload(true)} className="u_account-btn u_w-full u_cp">Reload</button>
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            {list.length === 0 ? (
                                <React.Fragment>
                                    <img src="../images/images/oops.png" className="u_m-auto"/>
                                    <CommonInvite heading="Oops!"
                                                  title="Either you are not a member of any organization or your system IP address doesn't fall under defined IP range criteria. Please contact the system administrator to get access."/>
                                    <div className="u_block u_relative">
                                        <button type="button" onClick={logout} className="u_account-btn u_w-full u_cp">Logout</button>
                                    </div>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <AppHeader header="Select Organization"
                                               title="You are a part of following organizations. Select the organization and Superworks product which you wish to access now."/>
                                    <div className="u_switch-organization">
                                        <ul className="u_organization-list">
                                            {list.map((data, i) => {
                                                return (
                                                    <li className={`u_rollover-options u_org-list u_one-line u_cp ${selectedOrg?._id === data?._id ? 'u_active' : ''}`}
                                                        key={i} onClick={() => selectOrg(data)}>
                                                        <div className="u_user-image u_cp u_flex ">
                                                            <div className="u_left-sidebar-logo">
                                                                <UAvatar name={data?.company} height={32} width={32} s3Url={_S3_BASE_URL} image={data?.logoURL}/>
                                                            </div>
                                                            <span className="u_company-name">{data?.company}</span>
                                                        </div>
                                                        <div className='u_content-between '>
                                                            <span className={`u_radio-icon ${selectedOrg?._id === data?._id ? 'u_active' : ''}`}/>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                            }
                                        </ul>
                                        {!isElectron() && <div className="u_select-place u_mt-20">
                                            <div className={`u_workspace-product u_flex u_flex-wrap u_content-center ${_ADMIN && 'u_survey-module'}`}>
                                                {selectedOrg?.planAccess?.hrms?.default?.access && ['admin', 'member'].includes(selectedOrg?.role) &&
                                                <div className={`u_module ${selectModule === 'hrms' ? 'u_active' : ''}`} onClick={() => setSelectModule('hrms')}>
                                                    <div className="u_module-inner"><Icon.HRMS size={32}/></div>
                                                    <h3>Super HRMS</h3>
                                                </div>}
                                                {selectedOrg?.planAccess?.chat?.default?.access && ['admin', 'member'].includes(selectedOrg?.role) &&
                                                <div className={`u_module ${selectModule === 'chat' ? 'u_active' : ''}`} onClick={() => setSelectModule('chat')}>
                                                    <div className="u_module-inner"><Icon.UbsChat size={32}/></div>
                                                    <h3>Super Chat</h3>
                                                </div>}
                                                {selectedOrg?.planAccess?.pms?.default?.access && ['admin', 'member', 'client'].includes(selectedOrg?.role) &&
                                                <div className={`u_module ${selectModule === 'pms' ? 'u_active' : ''}`} onClick={() => setSelectModule('pms')}>
                                                    <div className="u_module-inner"><Icon.PMS size={32}/></div>
                                                    <h3>Super PMS</h3>
                                                </div>}
                                                {selectedOrg?.planAccess?.payroll?.default?.access && ['admin', 'member'].includes(selectedOrg?.role) &&
                                                <div className={`u_module ${selectModule === 'payroll' ? 'u_active' : ''}`} onClick={() => setSelectModule('payroll')}>
                                                    <div className="u_module-inner"><Icon.PayrollLogo size={32}/></div>
                                                    <h3>Payroll</h3>
                                                </div>}
                                                {_ADMIN && selectedOrg?.planAccess?.survey?.default?.access && ['admin', 'member'].includes(selectedOrg?.role) &&
                                                <div className={`u_module ${selectModule === 'survey' ? 'u_active' : ''}`} onClick={() => setSelectModule('survey')}>
                                                    <div className="u_module-inner"><Icon.SurveyLogo size={26}/></div>
                                                    <h3>Survey</h3>
                                                </div>}
                                                {selectedOrg?.planAccess?.recruit?.default?.access && ['admin', 'member'].includes(selectedOrg?.role) &&
                                                <div className={`u_module ${selectModule === 'recruit' ? 'u_active' : ''}`} onClick={() => setSelectModule('recruit')}>
                                                    <div className="u_module-inner"><Icon.ATSLogo size={26}/></div>
                                                    <h3>Recruit</h3>
                                                </div>}
                                                {selectedOrg?.planAccess?.assets?.default?.access && ['admin', 'member'].includes(selectedOrg?.role) &&
                                                <div className={`u_module ${selectModule === 'assets' ? 'u_active' : ''}`} onClick={() => setSelectModule('assets')}>
                                                    <div className="u_module-inner"><Icon.AssetsLogo size={26}/></div>
                                                    <h3>Assets</h3>
                                                </div>}
                                            </div>
                                        </div>}
                                    </div>
                                    <div className="u_block u_relative u_mt-30">
                                        <button disabled={disabledBtn || !selectModule?.length} type="button" onClick={submit} className="u_account-btn u_w-full u_cp">Next</button>
                                        {disabledBtn && <div className="u_btn-loader"><Icon.Preloader size={70}/></div>}
                                    </div>
                                    {_IA?.isCompanyMFA && <div className="u_forgotpass u_mt-10">
                                        <span onClick={() => handle.editSetupMFA()} className="u_forgotpass__link u_cp">Update Multi-Factor Authenticate Setup?</span>
                                    </div>}
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}
                </div>
            </Layout>
            }
        </React.Fragment>
    )
}


export default withRouter(Workspace)

